module.exports = __webpack_public_path__ + "img/map_ref_section.b4fb9a9.png";